import React from 'react';
import packageJson from '../../package.json';
import './Footer.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="app-footer__container">
        <div className="app-footer__content">
          <span className="app-footer__copyright">
            © {currentYear} Viamericas. All rights reserved.
          </span>
          <span className="app-footer__version">
            v{packageJson.version}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
